module.exports = __webpack_public_path__ + "img/img-banner-plan.579161ef.png";